import translator from '@/locales';

export const APP_CREATION_STEPS = {
  UPLOAD_FILES: 'U',
  BASIC_INFO: 'B',
  IN_APP_PURCHASE: 'P',
  APP_INFO: 'A',
  SUPPORT_INFO: 'I',
  APP_MEDIA: 'M',
  FINAL_CHECK: 'F',
  COMMITTED: 'C',
};

export const STEPPER_ITEMS = [
  {
    title: translator.t('APPS.DRAFT.STEPS.UPLOAD_FILES'),
    key: APP_CREATION_STEPS.UPLOAD_FILES,
  },
  {
    title: translator.t('APPS.DRAFT.STEPS.BASIC_INFO'),
    key: APP_CREATION_STEPS.BASIC_INFO,
  },
  {
    title: translator.t('APPS.DRAFT.STEPS.IN_APP_PURCHASE'),
    key: APP_CREATION_STEPS.IN_APP_PURCHASE,
  },
  {
    title: translator.t('APPS.DRAFT.STEPS.APP_INFO'),
    key: APP_CREATION_STEPS.APP_INFO,
  },
  {
    title: translator.t('APPS.DRAFT.STEPS.SUPPORT_INFO'),
    key: APP_CREATION_STEPS.SUPPORT_INFO,
  },
  {
    title: translator.t('APPS.DRAFT.STEPS.APP_MEDIA'),
    key: APP_CREATION_STEPS.APP_MEDIA,
  },
  {
    title: translator.t('APPS.DRAFT.STEPS.FINAL_CHECK_SIDEBAR_TITLE'),
    key: APP_CREATION_STEPS.FINAL_CHECK,
  },
];
